import { Component, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'objetivo',
  templateUrl: 'objetivo.html'
})
export class ObjetivoComponent implements OnChanges {
  @Input() backButton: boolean = false;
  @Input() data: any;
  @Output() dataReturn: EventEmitter<any> = new EventEmitter<any>();
  @Output() iWantATotalIncome: EventEmitter<any> = new EventEmitter<any>();
  @Output() ageToLive: EventEmitter<any> = new EventEmitter<any>();
  @Output() formBack: EventEmitter<void> = new EventEmitter<void>();
  @Input() objetivo = {
    ingresosProyectados: 0,
    gatosEstimados: 0,
    deficitSuperHabit: 0,
    deseoUnIngresoTotal: 0,
    pensionExtra: 0,
    capitalRequerido: 0,
    edadQueVivire: 0
  };
  @Input() validation = {
    edadJubilacion: { col1: 55, col2: 70 },
    edadIngreso: { col1: 16, col2: 0 },
    edadActual: { col1: 16, col2: 95 },
    antiguedad: { col1: 0, col2: 0 },
    miEsperanzaDeVida: { col1: 0, col2: 110, },
    esperanzaDeVidaGeneral: { col1: 0, col2: 110 },
    semanasCotizadas: 0,
    anoImss: { col1: 0, col2: 0 },
    sueldoMensual: { col1: 0, col2: 0 },
    sueldoDiario: 0,
    factorInteg: { col1: 1, col2: 2 },
    ingresoNeto: { col1: 0, col2: 1000000 },
    planJubilacion: 0,
    planEquivaleEnIL: { col1: 0, col2: 5 },
    ahorrasParaJubilarte: { col1: true, col2: false },
    ahorroIndividual: { col1: 0, col2: 0 },
    anosAhorrando: { col1: 0, col2: 0 }
  };
  ////
  @Input() supuestos1 = {
    nombre: '',
    edadJubilacion: 0,
    edadIngreso: 0,
    edadActual: 0,
    antiguedad: 0,
    miEsperanzaDeVida: 0,
    esperanzaDeVidaGeneral: 0,
    semanasCotizadas: 0,
    anosCotiz: 0,
    anoImss: 1995,
    regimenJubilatorioImss: 1973,
    sueldoMensual: 0,
    sueldoIntegrado: 0,
    sueldoDiario: 0,
    factorInteg: 0,
    ingresoNeto: 0,
    planJubilacion: false,
    planEquivaleEnIL: 0,
    ahorrasParaJubilarte: false,
    ahorroIndividual: 0,
    saldoInicial: 0,
    anosAhorrando: 0,
    otrasInversiones: 0
  }
  @Input() pensiones = {
    imms: {
      val: 0,
      type: 0
    },
    empresa: 0,
    miAhorro: 0,
    inversiones: 0,
    adicional: 0,
    sueldo: 0
  }

  public doughnutChartDataopts = {
    legend: { display: false }
  }

  public colors = ['primary2', 'royal', 'secondary'];

  @Input() pensionesJubilacionSubTotal: number = 0;

  @Input() ahorro = {
    mensual: 0,
    conservador: 0,
    moderada: 0,
    optimista: 0
  };
  public dougnutChartcolors: Array<any> = [
    {
      backgroundColor: ['#007AA9', '#463685', '#59D7B5', '#f53d3d']
    }
  ];
  myForm: FormGroup;

  public doughnutChartType: string = 'doughnut';
  @Input() chartLabels: string[] = [''];
  @Input() doughnutChartData4: number[] = [0];
  public doughnutChartLabels4: string[] = ['Pensiones', 'Otros ingresos', 'Extra'];
  isInit: boolean = true;
  constructor(public formBuilder: FormBuilder) {
    this.myForm = formBuilder.group({
      iWantATotalIncome: [0],
      ageToLive: [0, [Validators.min(0)]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.objetivo = changes && changes.objetivo && changes.objetivo.currentValue ? changes.objetivo.currentValue : this.objetivo;
    if (this.isInit && changes && changes.objetivo && changes.objetivo.currentValue) {
      this.isInit = false;
    }
    this.ahorro = changes && changes.ahorro && changes.ahorro.currentValue ? changes.ahorro.currentValue : this.ahorro;
    this.validation = changes && changes.validation && changes.validation.currentValue ? changes.validation.currentValue : this.validation;
    this.supuestos1 = changes && changes.supuestos1 && changes.supuestos1.currentValue ? changes.supuestos1.currentValue : this.supuestos1;
    this.doughnutChartData4 = changes && changes.doughnutChartData4 && changes.doughnutChartData4.currentValue ? changes.doughnutChartData4.currentValue.map(element => { return Math.round(element); }) : this.doughnutChartData4;
  }

  ngOnInit() {
    if (this.data) {
      this.myForm.setValue(this.data);
    }
    this.myForm.get('ageToLive').setValidators([Validators.min(this.validation.miEsperanzaDeVida.col1), Validators.max(this.validation.miEsperanzaDeVida.col2)]);
  }

  change1(event) {
    this.iWantATotalIncome.emit(this.myForm.value.iWantATotalIncome);
  }
  change2(event) {
    this.ageToLive.emit(this.myForm.value.ageToLive);
  }

  submit() {
    this.dataReturn.emit(this.myForm.value);
  }

  back(): void {
    this.formBack.emit();
  }

}


// WEBPACK FOOTER //
// ./src/components/retirement-tools/retirement-calculator/objetivo/objetivo.ts